/* eslint-disable new-cap */
import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient, InMemoryCache } from 'apollo-boost';
import { createUploadLink } from 'apollo-upload-client';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import axios from 'axios';
import { buildAxiosFetch } from '@lifeomic/axios-fetch';

import store from './store';
import { getToken } from './utils';
import Auth from './auth';
import Alert from './components/Alert';
import Login from './pages/Login';
import ResetPassword from './pages/Password/Reset';

const httpLink = new createUploadLink({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
  fetch: buildAxiosFetch(axios, (config, input, init) => ({
    ...config,
    onUploadProgress: init.onUploadProgress,
  })),
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const options = {
  position: positions.TOP_CENTER,
  timeout: 3000,
  offset: '30px',
  transition: transitions.SCALE,
};

const HandleRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (!getToken() ? (
      <Component {...props} />
    ) : (
      <Redirect to="/dashboard" />
    ))
  }
  />
);

const App = () => (
  <AlertProvider template={Alert} {...options}>
    <Provider store={store}>
      <ApolloProvider client={client} style={{ height: '100%' }}>
        <BrowserRouter>
          <Switch>
            <HandleRoute path="/login" exact component={Login} />
            <HandleRoute path="/reset_password" exact component={ResetPassword} />
            <Route path="/dashboard" component={Auth} />
            <Route render={() => <Redirect to="/login" />} />
          </Switch>
        </BrowserRouter>
      </ApolloProvider>
    </Provider>
  </AlertProvider>
);

export default App;
